import type { VideoContentObject } from 'models';
import type { User } from 'features/auth';
import { isOrganizationAdminProfile, isOrganizationsAdmin, isSuperAdmin } from '../utils';

export const canEditVideo = ({ video, viewer }: { video: VideoContentObject; viewer: User }) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) ||
  isOrganizationAdminProfile({ organizationId: video.organization.id, viewer: viewer.railsUserData });

export const canDeleteVideo = ({ video, viewer }: { video: VideoContentObject; viewer: User }) =>
  canEditVideo({ video, viewer });

export const canArchiveVideo = ({ video, viewer }: { video: VideoContentObject; viewer: User }) =>
  canEditVideo({ video, viewer });

export const canCreateVideo = ({ viewer }: { viewer: User }) =>
  isSuperAdmin({ viewer: viewer.railsUserData }) || isOrganizationsAdmin({ viewer: viewer.railsUserData });

export const canViewVideos = ({ viewer }: { viewer: User }) => canCreateVideo({ viewer });
